import React from "react";
import { CheckCircle } from "lucide-react";
import Retailcycle from "./Retailcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
const travelLeadData = {
  heading: "Expand Your Retail Business with WhatsApp | ChatMitra",
  points: [
    "Showcase your retail products on WhatsApp with ChatMitra’s easy catalog feature.",
      "Answer customer questions in seconds using WhatsApp chatbots or live support.",
      "Boost sales with 95% open rates, leaving email’s 20% in the dust.",
    
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#076M54]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/lhsre1dbw7z4yuoz.webp?w=1024&dpr=2",
};


const retailServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🛒</span>, // Shopping cart icon
    title: "Drive Online Sales with WhatsApp",
    description: "Promote your products, share catalogs, and close sales directly on WhatsApp. It’s like having a virtual storefront that’s always open!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">📦</span>, // Package icon
    title: "Track Orders via WhatsApp",
    description: "Keep customers updated on shipping status, delays, and deliveries through WhatsApp. They’ll love the transparency and peace of mind."
  },
  {
    id: 3,
    icon: <span className="text-2xl">💸</span>, // Money icon
    title: "Simplify Payments on WhatsApp",
    description: "Send payment links, process refunds, and handle transactions all via WhatsApp. It’s secure, fast, and builds trust."
  },
  {
    id: 4,
    icon: <span className="text-2xl">📋</span>, // Checklist icon
    title: "Manage Inventory with WhatsApp",
    description: "Coordinate stock updates, restocks, and promotions through WhatsApp. It keeps your team and customers in sync effortlessly."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Customer Support on WhatsApp",
    description: "Answer queries, handle returns, and resolve issues in real time via WhatsApp. Your shoppers will feel valued and supported."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Collect Reviews via WhatsApp",
    description: "Ask for feedback on purchases and services through WhatsApp. It’s a quick way to improve and showcase your reliability."
  }
];

const retailFAQs = [
  {
    question: "How can WhatsApp grow my retail sales?",
    answer: "WhatsApp can boost your sales by promoting products, sharing catalogs, and handling orders directly with customers. It’s like having a virtual storefront that’s always open and ready to sell!"
  },
  {
    question: "Is WhatsApp secure for online retail transactions?",
    answer: "Yes, WhatsApp’s encryption keeps your product details and payment info safe. It’s like locking your store in a fortress, so customers can shop with confidence."
  },
  {
    question: "Can customers track orders on WhatsApp?",
    answer: "Absolutely! Send shipping updates, delivery statuses, and delays via WhatsApp. It’s like giving shoppers a personal tracker that keeps them in the loop."
  },
  {
    question: "How does WhatsApp help with retail customer support?",
    answer: "Offer real-time answers to queries, handle returns, and resolve issues via WhatsApp. It’s like having a friendly store associate available 24/7 to assist."
  },
  {
    question: "What retail content should I share on WhatsApp?",
    answer: "Share product launches, seasonal sales, and styling tips via WhatsApp. It’s a direct line to keep your audience excited and ready to shop."
  },
  {
    question: "Can WhatsApp manage my retail inventory?",
    answer: "Yes! Coordinate stock updates, restocks, and promotions through WhatsApp. It’s like having a control center that keeps your shelves full and sales flowing."
  },
  {
    question: "How do retail customers feel about WhatsApp?",
    answer: "They love it! Customers appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making shopping a delight."
  },
  {
    question: "Can WhatsApp reduce my retail operational costs?",
    answer: "Definitely! Automate responses to common questions and handle orders via WhatsApp, lowering overhead while improving service. It’s like doing more with less effort!"
  },
  {
    question: "How can I collect feedback on WhatsApp for retail?",
    answer: "Send surveys or ask for reviews on purchases and services via WhatsApp. It’s a quick way to improve and show customers you value their opinions."
  },
  {
    question: "How do I set up WhatsApp for my retail business?",
    answer: "Start with WhatsApp Business, create a catalog of products, and train your team to chat professionally. Tools like ChatMitra can help you launch fast and effectively!"
  },
];

const Retail = () => {
  return (
    <>
      <section className="flex flex-col md:flex-col lg:flex-row gap-8 md:gap-12 bg-white max-w-6xl mx-auto mt-32 mb-10 px-6 sm:px-0 pt-28">
        <div className="w-full md:w-full lg:w-1/2 text-left md:pl-8 mb-8 md:mb-0">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
            {travelLeadData.heading}
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            Transform your retail business with WhatsApp for retail automation. Engage customers effortlessly using ChatMitra’s powerful tools.
          </p>
          <ul className="mt-6 sm:mt-8 space-y-4 sm:space-y-6 text-lg">
            {travelLeadData.points.map((point, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="text-[#075E54] w-4 h-4 mr-2 self-center flex-shrink-0" strokeWidth={3} />
                {point}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-4 justify-left md:justify-start">
            {travelLeadData.buttons.map((button, index) => (
              <a
              key={index}
              href={button.buttonLink}
              className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
            >
              {button.text}
            </a>
            ))}
          </div>
        </div>
        <div className="w-full md:w-full lg:w-1/2 flex justify-center">
          <img
            src={travelLeadData.image}
            alt="WhatsApp for Retail with ChatMitra"
            className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
          />
        </div>
      </section>
      <Retailcycle />

      <WhatsAppServices servicesData={retailServices} isVisible={true}/>
      <Faqs faqs={retailFAQs} />
      <title>Expand Your Retail Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost your retail business with WhatsApp for retail automation. Use ChatMitra to showcase product catalogs, send personalized promotions, streamline orders, and provide instant customer support." />
      <meta name="keywords" content="WhatsApp for retail, retail automation, product catalogs, WhatsApp chatbot, customer engagement, ChatMitra" />
      <link rel="canonical" href="https://blog.chatmitra.com/whatsapp-business-for-offline-and-retail" />
      <meta property="og:title" content="Expand Your Retail Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Discover how WhatsApp for retail transforms offline and retail sectors with ChatMitra. Engage customers with catalogs, promotions, and instant support." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-offline-and-retail" />
      <meta property="og:type" content="website" />
      <Footer />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "WhatsApp for Retail",
            "provider": {
              "@type": "Organization",
              "name": "ChatMitra"
            },
            "description": "Enhance your retail business with WhatsApp automation tools including product catalogs, promotions, and customer support."
          }
        `}
      </script>
    </>
  );
};

export default Retail;